import {
  RESET,
  SET_CARD_READER_ZOOM_LEVEL,
  SET_CARD_POSITION,
  SET_FULL_SCREEN_MODE_ENABLED,
  CHANGE_SCREEN,
} from './actions';
import { CARD_POSITION_INITIAL } from '../../components/CardAndHand';

export const initialState = {
  screen: 'Home',
  previousScreen: null,
  cardPosition: CARD_POSITION_INITIAL,
  cardReaderZoomLevel: 1,
  isFullScreenModeEnabled: false,
};

const changeScreen = (state, screen) => {
  const previousScreen = state.screen;
  return { ...state, screen, previousScreen };
};

// eslint-disable-next-line
const ui = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return initialState;
    case CHANGE_SCREEN:
      return changeScreen(state, action.payload);
    case SET_CARD_READER_ZOOM_LEVEL:
      return { ...state, cardReaderZoomLevel: action.payload };
    case SET_CARD_POSITION:
      return { ...state, cardPosition: action.payload };
    case SET_FULL_SCREEN_MODE_ENABLED:
      return { ...state, isFullScreenModeEnabled: action.payload };
    default:
      return state;
  }
};

export default ui;
